import { useMemo } from "react";

import { RVConfirmationTriggerModalButton } from "@regal-voice/ui";
import { JourneyStatus } from "Types/Journey";

import { useTriggerEventNode } from "../../JourneyBuilder/shared/hooks/useTriggerEventNode";
import { SCHEDULED_JOURNEY_MESSAGE, NON_SCHEDULED_JOURNEY_MESSAGE } from "./constants";

export function SaveAsLiveButton({
    disabled,
    pendingOperation,
    handleSaveLive,
}: {
    disabled: boolean;
    pendingOperation: string | null;
    handleSaveLive: () => Promise<void>;
}): JSX.Element {
    const { isScheduledTrigger } = useTriggerEventNode();

    const modalContent = useMemo(() => {
        if (isScheduledTrigger) {
            return (
                <>
                    <span>{SCHEDULED_JOURNEY_MESSAGE}</span>
                </>
            );
        }
        return (
            <>
                <span>{NON_SCHEDULED_JOURNEY_MESSAGE}</span>
            </>
        );
    }, [isScheduledTrigger]);

    return (
        <RVConfirmationTriggerModalButton
            type="primary"
            disabled={disabled}
            loading={pendingOperation == JourneyStatus.LIVE}
            handleMethod={handleSaveLive}
            buttonText="Save as Live"
            title="Save Journey as Live?"
            content={modalContent}
            confirmText="Yes, Save as Live"
            okLoading="Saving As Live"
        />
    );
}
